import type { IconType } from "react-icons";
import { FaTableTennis } from "react-icons/fa";
import {
  FaBaseballBatBall,
  FaBasketball,
  FaFootball,
  FaFutbol,
  FaGolfBallTee,
  FaHockeyPuck,
  FaMedal,
  FaPersonBiking,
  FaVolleyball,
} from "react-icons/fa6";
import { GiBoxingGlove, GiDart, GiShuttlecock } from "react-icons/gi";
import { IoTennisball } from "react-icons/io5";
import { MdSportsCricket, MdSportsEsports, MdSportsMma, MdSportsRugby } from "react-icons/md";

const SPORT_ICON_BY_SLUG: Record<string, IconType> = {
  "american-football": FaFootball,
  "aussie-rules": FaFootball,
  badminton: GiShuttlecock,
  baseball: FaBaseballBatBall,
  basketball: FaBasketball,
  boxing: GiBoxingGlove,
  cricket: MdSportsCricket,
  cycling: FaPersonBiking,
  darts: GiDart,
  esports: MdSportsEsports,
  football: FaFutbol,
  futsal: FaFutbol,
  golf: FaGolfBallTee,
  handball: FaVolleyball,
  hockey: FaHockeyPuck,
  "ice-hockey": FaHockeyPuck,
  mma: MdSportsMma,
  rugby: MdSportsRugby,
  soccer: FaFutbol,
  "table-tennis": FaTableTennis,
  tennis: IoTennisball,
  volleyball: FaVolleyball,
};

export function getSportIcon(slug: string): IconType {
  return SPORT_ICON_BY_SLUG[slug] ?? FaMedal;
}
